import React, { FC, useCallback } from 'react'
import EditIcon from 'transfix-icons/build/EditIcon'
import { GridRenderCellParams } from 'transfix-ui/components/DataGrid/types'
import IconButton, { TIconButtonProps } from 'transfix-ui/components/IconButton'
import { IInboundFileRouterConfig } from 'types/graphqlTypes'

interface IEditInboundFileRouterConfigButtonProps {
  editParams: GridRenderCellParams
  items: IInboundFileRouterConfig[] | null
  setValues: React.Dispatch<React.SetStateAction<{}>>
  openEditHandler: () => void
}

export const EditInboundFileRouterConfigButton: FC<IEditInboundFileRouterConfigButtonProps> = ({
  editParams,
  items,
  openEditHandler,
  setValues,
}) => {
  const { row } = editParams
  const { id: rowId } = row

  const clickHandler: TIconButtonProps['onClick'] = useCallback(
    event => {
      event.stopPropagation()
      const currentRow = items?.find(row => row?.id === rowId)
      const parsedJsonData = JSON.stringify(currentRow?.shipperCodeJson ?? {}, null, 2)

      const {
        connectionType,
        disabled,
        environment,
        host,
        id,
        pathPrefix,
        port,
        secretKey,
        tmsName,
        username,
      } = currentRow ?? {}

      setValues({
        connectionType,
        disabled,
        environment,
        host,
        id,
        pathPrefix,
        port,
        secretKey,
        shipperCodeJson: parsedJsonData,
        tmsName,
        username,
      })

      openEditHandler()
    },
    [items, openEditHandler, rowId, setValues]
  )

  return (
    <IconButton Icon={EditIcon} label='Edit Inbound File Router Config' onClick={clickHandler} />
  )
}
